import styled from 'styled-components';

const PrivacyPage = () => (
  <Wrap>
    <Inner>
      <Title>개인정보 처리방침</Title>
      <Meta>시행일 2026-04-26 · 사업자 (주)이음플렛폼</Meta>

      <Lead>
        (주)이음플렛폼(이하 '회사')은 「개인정보 보호법」 등 관련 법령을 준수하며,
        이용자의 개인정보를 보호하기 위해 다음과 같이 개인정보 처리방침을 수립·공개합니다.
      </Lead>

      <H>제1조 (개인정보 수집 항목 및 방법)</H>
      <Body>
        1) 수집 항목
        <Ul>
          <li>필수: 이름, 이메일, 휴대전화번호, 비밀번호(암호화), 사업자등록번호, 사업자등록증 이미지, 대표자명</li>
          <li>선택: 사무실 주소, 추천인 정보, 대표 전화, 프로필 사진</li>
          <li>자동 수집: 접속 IP, 쿠키, 디바이스 식별자, 푸시 토큰, 서비스 이용 기록</li>
        </Ul>
        2) 수집 방법: 회원가입, 서비스 이용 과정, 사업자등록증 업로드, 푸시 토큰 등록
      </Body>

      <H>제2조 (개인정보 수집 및 이용 목적)</H>
      <Ul>
        <li>회원 식별 및 가입 의사 확인</li>
        <li>사업자등록 진위확인 및 사업자 자격 검증 (국세청 API 연동)</li>
        <li>서비스 매칭 및 정산 처리</li>
        <li>알림톡 / SMS / 푸시 발송</li>
        <li>고객 문의 응대 및 분쟁 해결</li>
        <li>법령상 의무이행 및 부정 이용 방지</li>
      </Ul>

      <H>제3조 (개인정보 보유 및 이용 기간)</H>
      <Body>회원 탈퇴 시까지 보유. 단, 관련 법령에 따라 일정 기간 보관:</Body>
      <Ul>
        <li>계약 또는 청약철회 기록: 5년 (전자상거래법)</li>
        <li>대금결제 및 재화 공급 기록: 5년</li>
        <li>소비자 불만 또는 분쟁처리 기록: 3년</li>
        <li>로그인 기록: 3개월 (통신비밀보호법)</li>
      </Ul>

      <H>제4조 (개인정보 제3자 제공)</H>
      <Body>
        회사는 이용자의 동의 없이 개인정보를 외부에 제공하지 않습니다. 단, 다음 경우는 예외입니다:
      </Body>
      <Ul>
        <li>이용자가 사전에 동의한 경우 (예: 제휴업체 매칭 시 고객 정보 일부 제공)</li>
        <li>법령의 규정에 의거하거나 수사기관의 적법한 요청이 있는 경우</li>
      </Ul>
      <Body>제휴업체 매칭 시 제공 정보: 고객명 / 연락처 / 희망 서비스 / 지역. 수령 즉시 해당 제휴업체에 한해서만 사용됩니다.</Body>

      <H>제5조 (개인정보 처리 위탁)</H>
      <Table>
        <thead><tr><th>수탁업체</th><th>위탁 업무</th></tr></thead>
        <tbody>
          <tr><td>Google Firebase</td><td>회원 인증, 데이터 저장, 푸시 알림</td></tr>
          <tr><td>네이버 클라우드 (CLOVA OCR)</td><td>사업자등록증 자동 인식</td></tr>
          <tr><td>국세청 (data.go.kr)</td><td>사업자번호 진위 및 상태 확인</td></tr>
          <tr><td>솔라피 (Solapi)</td><td>SMS / 알림톡 발송</td></tr>
          <tr><td>토스페이먼츠</td><td>결제 처리</td></tr>
        </tbody>
      </Table>

      <H>제6조 (이용자 권리 및 행사 방법)</H>
      <Ul>
        <li>이용자는 언제든지 개인정보 열람·정정·삭제·처리정지를 요구할 수 있습니다.</li>
        <li>요구 방법: 앱 내 마이페이지 또는 desk@ieum.in</li>
        <li>회원 탈퇴: 앱 내 마이페이지 → 회원탈퇴</li>
      </Ul>

      <H>제7조 (개인정보 파기)</H>
      <Ul>
        <li>전자 파일: 복구 불가능한 방법으로 영구 삭제</li>
        <li>출력물: 분쇄 또는 소각</li>
        <li>파기 시점: 보유 기간 경과 또는 처리 목적 달성 후 지체 없이</li>
      </Ul>

      <H>제8조 (개인정보 안전성 확보 조치)</H>
      <Ul>
        <li>비밀번호 일방향 암호화 저장</li>
        <li>전송 구간 SSL/TLS 암호화</li>
        <li>접근권한 최소화 및 기록 관리</li>
        <li>개인정보 취급 직원 교육</li>
      </Ul>

      <H>제9조 (쿠키 및 디바이스 식별자)</H>
      <Body>
        서비스 이용 편의 및 통계 분석 목적으로 쿠키 및 디바이스 식별자를 사용합니다.
        이용자는 브라우저 설정 또는 디바이스 설정에서 거부할 수 있으나, 일부 서비스 이용에 제한이 있을 수 있습니다.
      </Body>

      <H>제10조 (개인정보 보호책임자)</H>
      <Table>
        <tbody>
          <tr><th>책임자</th><td>이은송 (대표)</td></tr>
          <tr><th>이메일</th><td>desk@ieum.in</td></tr>
          <tr><th>전화</th><td>070-7666-9413</td></tr>
        </tbody>
      </Table>

      <H>제11조 (권익침해 구제 방법)</H>
      <Ul>
        <li>개인정보분쟁조정위원회: 1833-6972 (privacy.kisa.or.kr)</li>
        <li>개인정보침해신고센터: 118 (privacy.kisa.or.kr)</li>
        <li>대검찰청 사이버수사과: 1301 (spo.go.kr)</li>
        <li>경찰청 사이버수사국: 182 (cyberbureau.police.go.kr)</li>
      </Ul>

      <H>제12조 (개인정보 처리방침 변경)</H>
      <Body>본 방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경 사항이 있을 경우 시행 7일 전 공지합니다.</Body>

      <Footer>
        최종 수정일 2026-04-26 · 시행일 2026-04-26<br />
        운영 주체 (주)이음플렛폼 · 사업자등록번호 633-88-03692<br />
        주소 경기도 시흥시 서울대학로278번길 19-14, 배곧프라자 706호
      </Footer>
    </Inner>
  </Wrap>
);

const Wrap = styled.div`
  min-height: 100vh;
  background: #fff;
  padding: 32px 16px 80px;
`;
const Inner = styled.div`
  max-width: 760px;
  margin: 0 auto;
  font-family: 'Apple SD Gothic Neo', 'Pretendard', sans-serif;
  color: #1F2937;
  line-height: 1.7;
  font-size: 14px;
`;
const Title = styled.h1`
  font-size: 26px;
  font-weight: 700;
  border-bottom: 3px solid #4A6CF7;
  padding-bottom: 12px;
  margin: 0 0 8px;
`;
const Meta = styled.div`
  color: #6B7280;
  font-size: 12px;
  margin-bottom: 32px;
`;
const Lead = styled.p`
  background: #F9FAFB;
  padding: 14px 16px;
  border-radius: 6px;
  margin: 0 0 28px;
`;
const H = styled.h2`
  font-size: 16px;
  color: #4A6CF7;
  border-left: 3px solid #4A6CF7;
  padding-left: 10px;
  margin: 28px 0 10px;
`;
const Body = styled.p`margin: 8px 0;`;
const Ul = styled.ul`padding-left: 20px; margin: 8px 0;`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 13px;
  th, td { border: 1px solid #E5E7EB; padding: 8px 12px; text-align: left; vertical-align: top; }
  th { background: #F3F4F6; font-weight: 600; }
`;
const Footer = styled.div`
  margin-top: 40px;
  padding: 16px;
  background: #F9FAFB;
  border-radius: 6px;
  font-size: 12px;
  color: #6B7280;
  line-height: 1.7;
`;

export default PrivacyPage;
